import React from "react";
import { SettingItem } from "./SettingItem";

interface PreferenceState {
  inApp: boolean;
  email: boolean;
}

interface SettingItemsProps {
  preferences: PreferenceState;
  onPreferenceChange: (type: "inApp" | "email", value: boolean) => void;
}

export const NotificationSettingItems: React.FC<SettingItemsProps> = ({
  preferences,
  onPreferenceChange,
}) => {
  return (
    <div className="space-y-3">
      <SettingItem
        label="In-app notifications"
        checked={preferences.inApp}
        onChange={(value) => onPreferenceChange("inApp", value)}
      />
      <SettingItem
        label="Email notifications"
        checked={preferences.email}
        onChange={(value) => onPreferenceChange("email", value)}
      />
    </div>
  );
};
